<template>
  <section>
    <h3 class="primary--text"><router-link class="no-link-style" style="font-weight:500" :to="{ name: 'Case', params: { case_id: eventDateObj.caseId} }"> {{ eventDateObj.title }}</router-link> {{ text }}</h3>
  </section>
</template>

<script>
import Helpers from "@/helpers.js"
import { mapState } from 'vuex'
export default {
  name: "SinglePrefixTitle",
  props: ["eventDateObj", "text"],
  computed: {
    ...mapState({
      internalFields: state => state.caseTypes.internalFields,
      timePref: state => (state && state.currentUser && state.currentUser.me &&
                            state.currentUser.me.preferences && state.currentUser.me.preferences.dateTimeFormat)
        ? state.currentUser.me.preferences.dateTimeFormat : "HH:MM, D MMM"
    })
  },
  created() {
    if (this.eventDateObj.params && this.eventDateObj.params.changedFields) {
      this.handleUpdateCase()
    }
  },
  methods: {
    handleUpdateCase() {
      const caseType = Helpers.getCaseTypeById(this.$store.state, this.eventDateObj.caseType.id)
      if (caseType && caseType.currentSchema && caseType.currentSchema.fieldsets) {
        const fieldTypes = this.getFieldTypes(caseType)
        if (fieldTypes) {
          this.formatFields(fieldTypes, caseType)
        }
      }
    },
    getFieldTypes(caseType) {
      const fieldTypes = []
      this.internalFields.forEach(field => {
        fieldTypes[field.name] = field
      })
      caseType.currentSchema.fieldsets.forEach(fieldset => {
        fieldset.fields.forEach(field => {
          fieldTypes[field.name] = field
        })
      })
      return fieldTypes
    },
    formatFields(fieldTypes, caseType) {
      this.eventDateObj.params.changedFields.forEach(change => {
        if (change) {
          const name = change.name.toLowerCase()
          if (change.rows) {
            const rowTypes = fieldTypes[change.name].fields
            const rowHeaders = change.headers
            change.rows.forEach(row => {
              if (rowHeaders) {
                for (let i = 0; i < rowHeaders.length; i++) {
                  const typeIndex = rowTypes.map((type) => type.name).indexOf(rowHeaders[i])
                  row.from[i] = this.formatField(rowTypes[typeIndex], row.from[i])
                  row.to[i] = this.formatField(rowTypes[typeIndex], row.to[i])
                }
              }
            })
          }
          change.from = this.formatField(fieldTypes[name], change.from)
          change.to = this.formatField(fieldTypes[name], change.to)
          change.name = this.findDisplayName(name, caseType)
        }
      })
    },
    findDisplayName(name, caseType) {
      if (caseType && caseType.currentSchema && caseType.currentSchema.fieldsets) {
        const fieldTypes = this.getFieldNames(caseType)
        if (fieldTypes) {
          if (fieldTypes[name]) {
            return fieldTypes[name]
          }
        }
      }
      return Helpers.capitalizeRemoveUnderscores(name)
    },
    getFieldNames(caseType) {
      const fieldTypes = []
      caseType.currentSchema.fieldsets.forEach(fieldset => {
        fieldset.fields.forEach(field => {
          fieldTypes[field.name] = field.display_name
        })
      })
      return fieldTypes
    },
    formatField(field, value) {
      if (field) {
        switch (field.type) {
          case "date":
            return Helpers.formatDate(value, this.timePref)
          case "boolean":
            return value === "true" ? "Yes" : "No"
          case "number":
            if (field.display === "currency") {
              return field.symbol + value
            } else {
              return value
            }
          case "password":
            return "[password changed]"
          default:
            return value
        }
      } else {
        return value
      }
    }
  }
}
</script>
